import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import SideNav from './Partials/SideNav';
import { qprService } from '../../../../Services';
import { qprActions } from '../../../../Actions';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

const ProgressReportForm = () => {
  const location = useLocation();
  const { qpr_id, qh } = location.state;
  const qpr = useSelector((state) => state.qpr_data);
  const dispatch = useDispatch();

  const [submitted, setSubmitted] = useState(false);
  const [drafted, setDrafted] = useState(false);

  const [input, setInput] = useState(qpr.progress_report && Object.keys(qpr.progress_report).length>0? qpr.progress_report: {
    activity_planned: '',
    planned_activity_status: '',
    non_performance_reason: '',
    non_performance_project_plan: '',
    progress_summery: '',
    author_name: '',
    paper_title: '',
    journal: '',
    volume: '',
    year: '',
    page_number: '',
    research_paper: '',
    other_update: '',
  });

  useEffect( () => {
    if(typeof qpr.progress_report == "undefined") {
      qprService.progressReport(qpr_id).then(rslt => {
        Object.keys(rslt.data.progress_report).map(val => {
          rslt.data.progress_report[val] = rslt.data.progress_report[val] ?? "";
        });
        qpr.progress_report = rslt.data.progress_report;
        qpr.form_validation = JSON.parse(rslt.data.progress_report.form_validation);
        localStorage.setItem("qpr_data", JSON.stringify(qpr));
        dispatch(qprActions.qprData(qpr));
        setInput(qpr.progress_report);
      });
    }
  }, []);

  const [validationError, setValidationError] = useState({});
  const ref = useRef([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput(input => ({ ...input, [name]: value }));
  }

  const checkValidation = () => {
    let error = {};
    Object.keys(input).map(item => {
      if((!input[item]) && !["user_status", "other_update", "author_name", "paper_title", "journal", "volume", "year", "page_number"].includes(item)) {
        error[item] = "Required";
      }
    });

    if(Object.keys(error).length>0) {
      setValidationError(error);
      const ref_focus_key = Object.keys(error)[0];
      ref.current[ref_focus_key].focus();
    }
    return error;
  }

  const submitForm = (submit_status, fnctn) => {
    setValidationError({});
    qpr.form_validation.progress_report.submit_status = 0;
    input.submit_status = 0;
    if(submit_status == 1) {
      input.submit_status = 1;
      if(Object.keys(checkValidation()).length > 0) {
        fnctn(false);
        return false;
      }
      qpr.form_validation.progress_report.submit_status = 1;
    }
    input.form_validation = JSON.stringify(qpr.form_validation);
    qprService.progressReportSave(input, qpr_id).then(rslt => {
      Object.keys(rslt.data.progress_report).map(val => {
        rslt.data.progress_report[val] = rslt.data.progress_report[val] ?? "";
      });
      qpr.progress_report = rslt.data.progress_report;
      localStorage.setItem("qpr_data", JSON.stringify(qpr));
      dispatch(qprActions.qprData(qpr));
      fnctn(false);
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let submit_status = e.target.dataset.submit_status;
    let fnctn = submit_status==1? setSubmitted: setDrafted;
    fnctn(true);
    submitForm(submit_status, fnctn);
  }
  return (
    <>
      <section className="pt-4 pb-50 content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h5>{qh}</h5>
              </div>
              <div className='row mt-4'>
                <div className='col-md-4'>
                  <SideNav />
                </div>
                <div className='col-md-8'>
                  <div className='card border-info' style={{"borderTop": "3px solid"}}>
                    <div className='card-header'><h6>Progress Report</h6></div>
                    <div className="contact-from pt-0">
                      <div className="main-form">
                        <form onSubmit={handleSubmit} data-submit_status={1}>
                          <div className='singel-form'>
                            <h6>Planned vs Achieved Progress in the Quarter:</h6>
                            <div className='singel-form'>
                              <label>What activities were planned for this quarter?<span className='text-danger'>*</span>:</label>
                              <textarea name='activity_planned' value={input.activity_planned && input.activity_planned} ref={r => {ref.current['activity_planned'] = r}} onChange={handleChange} ></textarea>
                            {validationError.activity_planned && <span className='text-danger'>{validationError.activity_planned}</span>}


                            </div>
                            <div className='singel-form'>
                              <label>What is the current status of the planned activities?<span className='text-danger'>*</span>:</label>
                              <textarea name='planned_activity_status' value={input.planned_activity_status && input.planned_activity_status} ref={r => {ref.current['planned_activity_status'] = r}} onChange={handleChange} ></textarea>
                            {validationError.planned_activity_status && <span className='text-danger'>{validationError.planned_activity_status}</span>}
                            </div>
                            <div className='singel-form'>
                              <label>What are the reasons for under/non-performance?<span className='text-danger'>*</span>:</label>
                              <textarea name='non_performance_reason' value={input.non_performance_reason && input.non_performance_reason} ref={r => {ref.current['non_performance_reason'] = r}} onChange={handleChange} ></textarea>
                            {validationError.non_performance_reason && <span className='text-danger'>{validationError.non_performance_reason}</span>}
                            </div>
                            <div className='singel-form'>
                              <label>In case of delay or under/non-performance, what is the plan for completing the project on time?<span className='text-danger'>*</span>:</label>
                              <textarea name='non_performance_project_plan' value={input.non_performance_project_plan && input.non_performance_project_plan} ref={r => {ref.current['non_performance_project_plan'] = r}} onChange={handleChange} ></textarea>
                            {validationError.non_performance_project_plan && <span className='text-danger'>{validationError.non_performance_project_plan}</span>}
                            </div>
                          </div>
                          <div className='singel-form'>
                            <label>Summary report of progress (Not more than 300 words)<span className='text-danger'>*</span>:</label>
                            <textarea name='progress_summery' value={input.progress_summery && input.progress_summery} ref={r => {ref.current['progress_summery'] = r}} onChange={handleChange} ></textarea>
                            {validationError.progress_summery && <span className='text-danger'>{validationError.progress_summery}</span>}
                          </div>
                          <hr/>
                          {/* <hr/> */}
                          <div className='singel-form'>
                          <label><h6>Please provide any research papers/conferences/patents submitted or published:</h6></label>
                            <textarea name='research_paper' value={input.research_paper ?? ""} ref={r => {ref.current['research_paper'] = r}} onChange={handleChange}></textarea>
                            {validationError.research_paper && <span className='text-danger'>{validationError.research_paper}</span>}
                          </div>
                          {/* <div className='singel-form'>
                            <h6>Please provide any research papers/conferences/patents submitted or published:</h6>
                            <div className='singel-form'>
                              <div className="row">
                                <div className='col-md-4'>
                                  <label>Author name:</label>
                                  <input type="text" name='author_name' value={input.author_name && input.author_name} ref={r => {ref.current['author_name'] = r}} onChange={handleChange} />
                                  {validationError.author_name && <span className='text-danger'>{validationError.author_name}</span>}
                                </div>
                                <div className='col-md-4'>
                                  <label>Title of the paper:</label>
                                  <input type="text" name='paper_title' value={input.paper_title && input.paper_title} ref={r => {ref.current['paper_title'] = r}} onChange={handleChange} />
                                  {validationError.paper_title && <span className='text-danger'>{validationError.paper_title}</span>}
                                </div>
                                <div className='col-md-4'>
                                  <label>Journal/ Conference/ Workshop:</label>
                                  <input type="text" name='journal' value={input.journal && input.journal} ref={r => {ref.current['journal'] = r}} onChange={handleChange} />
                                  {validationError.journal && <span className='text-danger'>{validationError.journal}</span>}
                                </div>
                              </div>
                            </div>
                            <div className='singel-form'>
                              <div className="row">
                                <div className='col-md-4'>
                                  <label>Volume:</label>
                                  <input type="text" name='volume' value={input.volume && input.volume} ref={r => {ref.current['volume'] = r}} onChange={handleChange} />
                                  {validationError.volume && <span className='text-danger'>{validationError.volume}</span>}
                                </div>
                                <div className='col-md-4'>
                                  <label>Year:</label>
                                  <input type="text" name='year' value={input.year && input.year} ref={r => {ref.current['year'] = r}} onChange={handleChange} />
                                  {validationError.year && <span className='text-danger'>{validationError.year}</span>}
                                </div>
                                <div className='col-md-4'>
                                  <label>Page number:</label>
                                  <input type="text" name='page_number' value={input.page_number && input.page_number} ref={r => {ref.current['page_number'] = r}} onChange={handleChange} />
                                  {validationError.page_number && <span className='text-danger'>{validationError.page_number}</span>}
                                </div>
                              </div>
                            </div>
                          </div> */}
                          {/* <hr/> */}
                          <div className='singel-form'>
                            <label><h6>Please share the link of images or videos captured during project experiments, field work, stakeholder engagement etc:</h6></label>
                            <textarea name='other_update' value={input.other_update ?? ""} ref={r => {ref.current['other_update'] = r}} onChange={handleChange}></textarea>
                            {validationError.other_update && <span className='text-danger'>{validationError.other_update}</span>}
                          </div>
                          <hr/>
                          <p className="form-message"></p>
                          <div className="singel-form">
                            <button type="button" className="main-btn btn-info btn-outline-info disabled" onClick={submitted? '': handleSubmit} data-tip data-for="draft">
                              {drafted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Draft</span>}
                            </button>
                            <ReactTooltip id="draft" place="top" effect="solid">
                              You can save the form as draft if you do not have all the required information to fill
                            </ReactTooltip>
                            <button type={submitted? "button": "submit"} className="main-btn btn-info ml-3 disabled">
                              {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Save</span>}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProgressReportForm;